<div class="container p-4 h-100 d-flex flex-column">
  <div class="d-flex justify-content-between align-items-start w-100 mb-2">
    <div class="back-btn-container">
      <app-back-button></app-back-button>
    </div>
    <app-bhashini-language-translation></app-bhashini-language-translation>
  </div>
  <div class="d-flex justify-content-start flex-column align-items-center">
    <img
      fetchpriority="high"
      width="136"
      height="90"
      src="images/ai-kosh-logo.svg"
      alt="AIKosh"
      title="AIKosh"
      class="cursor-pointer"
      (click)="redirectToHome()"
    />
    <h1 class="text-3xl mt-2 fw-600">Welcome to the Platform</h1>

    <div class="p-3 text-center">
      <h1 class="text-2xl fw-600">Step 2 : Choose Your Registration Method</h1>
      <p class="text-base text__gray mb-0">
        Choose your preferred method to create your account
      </p>
    </div>
  </div>

  <!-- Role Cards -->

  <div class="d-flex flex-column justify-content-between flex-grow-1">
    <ng-container *ngTemplateOutlet="roleCards"></ng-container>

    <!-- Already have account -->
    <div class="text-center my-4" (click)="redirectToLogin()">
      <span>
        Already have an account?
        <span class="text-decoration-underline cursor-pointer">Login</span>
      </span>
    </div>
  </div>
</div>

<ng-template #roleCards>
  <div
    class="w-auto w-lg-100 d-flex gap-4 justify-content-center flex-wrap flex-lg-nowrap"
  >
    <!-- Explorer Role Card -->
    <ng-container
      *ngTemplateOutlet="roleCard; context: emailRegistration"
    ></ng-container>

    <!-- Explorer Role Card -->
    <ng-container
      *ngTemplateOutlet="roleCard; context: janParichayRegistration"
    ></ng-container>

    <!-- Contributor Role Card -->
    <!-- <ng-container
      *ngTemplateOutlet="roleCard; context: meriPehchaanRegistration"
    ></ng-container> -->

    <!-- Organization Admin Role Card -->
    <!-- <ng-container
      *ngTemplateOutlet="roleCard; context: parichayRegistration"
    ></ng-container> -->
  </div>
</ng-template>

<!-- Role Card Template -->
<ng-template
  #roleCard
  let-icon="icon"
  let-title="title"
  let-description="description"
  let-permissions="permissions"
  let-recommendation="recommendation"
  let-note="note"
  let-buttonText="buttonText"
  let-id="id"
  let-isRecommended="isRecommended"
>
  <div
    class="p-4 card-container role-card d-flex flex-column justify-content-between gap-3 flex-grow-1 flex-lg-grow-0"
  >
    <div class="d-flex flex-column justify-content-between gap-2 h-100">
      <div>
        <div class="d-flex gap-2 justify-content-between">
          <!-- Icon -->
          <img
            class="flex-shrink-0 mb-3"
            fetchpriority="high"
            height="40"
            [src]="icon"
            alt="Individual"
          />
          @if (isRecommended) {
            <div class="fw-600 recco-btn">Recommended</div>
          }
        </div>

        <!-- Title & Description -->
        <div class="text-base fw-700 mb-2">{{ title }}</div>
        <div class="text-base mb-3">{{ description }}</div>
      </div>

      <!-- Key Permissions -->
      <!-- <div> -->
      <div
        *ngFor="let permission of permissions"
        class="flex items-start gap-2"
      >
        <img src="images/success.svg" alt="Success" width="15" height="15" />
        <span class="text-base ms-2">{{ permission }}</span>
      </div>
    </div>
    <!-- </div> -->

    <div
      class="w-100 d-flex flex-column justify-content-between gap-2 recco-btn-section h-100"
    >
      <!-- Recommendation Box -->
      @if (recommendation) {
        <div class="bg-primary-bg p-3 mb-2 rounded-3">
          <span class="text-sm">{{ recommendation }}</span>
          @if (note) {
            <br />
            <span class="text-sm fw-600 mt-1">
              {{ note }}
            </span>
          }
        </div>
      } @else {
        <div></div>
      }
      <!-- Select Button -->
      <button class="btn btn-secondary" (click)="onRegistration(id)">
        <span class="text-base">{{ buttonText }}</span>
        <span
          ><img src="images/arrow-right-gray.svg" class="ms-2" alt=""
        /></span>
      </button>
    </div>
  </div>
</ng-template>
